import { Navigate, useLocation } from 'react-router';

const GuidedSellingExperienceRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const newPathname = pathname.replace(/^\/scouting_report/, '/guided_selling_experience');

  return <Navigate replace to={`${newPathname}${search}${hash}`} />;
};

export default GuidedSellingExperienceRedirect;
